module.exports = __webpack_public_path__ + "static/media/plantPal2_05.fd643b68.gif";